import { Box, Container, Divider, Link as MuiLink, Stack, Typography } from "@mui/material";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import z from "zod";
import { Logo } from "@/components/core/logo";
import { NotFound } from "@/components/not-found";
import { TopBar } from "@/components/top-bar-portal";
import { usePortal } from "@/models/backend";

const search = z.object({
  token: z.uuid(),
});

export const Route = createFileRoute("/_portal")({
  component: RouteComponent,
  validateSearch: search,
  errorComponent: NotFound,
});

function RouteComponent() {
  const { token } = Route.useSearch();
  const { data: customer } = usePortal({ token });
  return (
    <Box
      sx={{
        minHeight: "100%",
      }}
    >
      <TopBar organization={customer?.organization} />
      <Box
        sx={{
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          pl: "0",
          pt: "104px",
          "@media print": {
            pl: "0",
          },
        }}
      >
        <main>
          <Container maxWidth="lg" sx={{ py: 4 }}>
            <Outlet />
            <Divider sx={{ padding: 5 }} />
            <Stack
              direction="row"
              spacing={2}
              sx={{
                "@media print": { display: "none" },
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MuiLink
                href="https://trove.works"
                target="_blank"
                sx={{
                  verticalAlign: "bottom",
                  justifySelf: "bottom",
                  flex: 1,
                }}
              >
                <Typography variant="caption">
                  Powered by{" "}
                  <Logo
                    sx={{ display: "inline", verticalAlign: "bottom" }}
                    width={92}
                    height={20}
                  />
                </Typography>
              </MuiLink>
              <MuiLink href="https://trove.works/terms-and-conditions">
                <Typography variant="overline" color="text.secondary">
                  Terms and Conditions
                </Typography>
              </MuiLink>
              <Divider orientation="vertical" flexItem />
              <MuiLink href="https://trove.works/privacy-notice">
                <Typography variant="overline" color="text.secondary">
                  Privacy Policy
                </Typography>
              </MuiLink>
              <Divider orientation="vertical" flexItem />
              <MuiLink href="https://trove.works/support-by-trove/">
                <Typography variant="overline" color="text.secondary">
                  Support
                </Typography>
              </MuiLink>
              <Box sx={{ flex: 1, visibility: "hidden" }} />
            </Stack>
          </Container>
        </main>
      </Box>
    </Box>
  );
}
